/** @format */
import React from 'react';
import { Grid } from '@mui/material';
import { useStyles } from './Style';
import { useTargetUser } from 'hooks';
import jMoment from 'moment-jalaali';
import { PriceLabel } from 'components';

const Overview = ({ data  , currencyText}) => {
  const classes = useStyles();
  const targetUser = useTargetUser();

  const mapedData = [
    {
      key: 'صنف',
      value: data.guildSrv?.name || '-',
    },
    {
      key: 'مجموع',
      value:<PriceLabel amount={data?.totalAmount} currency={currencyText} />,
    },
    {
      key: 'مجموع بدون تخفیف',
      value: <PriceLabel amount={data?.totalAmountWithoutDiscount} currency={currencyText} />,
    },
    {
      key: 'مجموع قابل پرداخت',
      value: <PriceLabel amount={data?.payableAmount} currency={currencyText} />,
    },
    {
      key: 'امکان اعمال بن تخفیف پس از صدور',
      value: data.postVoucherEnabled ? 'بله' : 'خیر',
    },
    {
      key: 'نیاز به تایید شما پس از پرداخت',
      value: data.verificationNeeded ? 'بله' : 'خیر',
    },
    {
      key: 'تاریخ صدور',
      value: new jMoment(data.issuanceDate).format('jYYYY/jMM/jDD'),
    },
    {
      key: 'تاریخ سررسید',
      value: new jMoment(data.deliveryDate).format('jYYYY/jMM/jDD'),
    },
    {
      key: 'شماره پرداخت قبض',
      value: data.paymentBillNumber,
    },
    {
      key: 'شناسه یکتا',
      value: data.uniqueNumber,
    },
    {
      key: 'کاربر',
      value: `${targetUser?.userId || '-'} . ${
        targetUser?.fullName || targetUser?.username || '-'
      }`,
    },
  ];
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={2}
      item
      xs={12}
      className={classes.root}
    >
      <Grid item xs={12}>
        {mapedData.map((item) => (
          <li className={classes.listHeadLine}>
            {item.key}: <span className={classes.listHeadLineValue}>{item.value}</span>
          </li>
        ))}
      </Grid>
    </Grid>
  );
};

export default Overview;
